import axios from 'axios';

class ApiClient {
	constructor() {
		this.apiClient = axios.create({
			baseURL: process.env.REACT_APP_API_URI,
			withCredentials: true,
		});
	}

	// AUTH-RELATED ROUTES
	me() {
		return this.apiClient.get('/whoami').then(response => response.data);
	}

	login(user) {
		const { username, password } = user;
		return this.apiClient.post('/login', { username, password }).then(({ data }) => data);
	}

	logout() {
		return this.apiClient.post('/logout', {}).then(response => response.data);
	}

	// SONG-RELATED ROUTES
	getOneSong(songId) {
		return this.apiClient.get(`/admin/${songId}`).then(response => response.data);
	}
	
	getAllSongs() {
		return this.apiClient.get('/allsongs').then(response => response.data);
	}

	getGigSongs() {
		return this.apiClient.get('/gigsongs').then(response => response.data);
	}

	getVotedSongs() {
		return this.apiClient.get('/votedsongs').then(response => response.data);
	}
	
	addSong(song) {
		const { id, artist, name } = song;
		return this.apiClient.post('/admin/song', { id, artist, name }).then(response => response);
	}

	editSong(id, song) {
		return this.apiClient.put(`/admin/${id}`, { id, song }).then(response => response);
	}
	
	playedSong(id) {
		return this.apiClient.put('/admin/playedsong', { id }).then(response => response.data);
	}

	deleteSong(id) {
		return this.apiClient.delete(`/admin/${id}`).then(response => response);
	}
	
	// GIG-RELATED ROUTES
	addGig(gig) {
		const { place, day, songs } = gig;
		return this.apiClient.post('/admin/gig', { place, day, songs }).then(response => response.data);
	}

	getGig() {
		return this.apiClient.get('/admin/gig').then(response => response.data);
	}

	editGig(songs) {
		return this.apiClient.put('/admin/gig', { songs }).then(response => response.data);
	}

	endGig() {
		return this.apiClient.put('/admin/end').then(response => response.data);
	}

	// VOTE-RELATED ROUTES
	vote({ username, songs, lang }) {
		return this.apiClient.post('/vote', { username, songs }).then(response => response);
	}
}

const apiClient = new ApiClient();

export default apiClient;
